import produce from 'immer';
import { convertChannelCasing } from 'lib-shared-api-utils';
import { Conversation, MetaConversation } from 'lib-shared-legacy-types';
import type { SearchConversationHit } from 'lib-shared-types-api';

export const convertHitToMetaConversation = (
  hit: SearchConversationHit,
): MetaConversation => {
  const metaConversation: MetaConversation = {
    callersOnHold: [],
    conversation: produce({} as Conversation, (draft) => {
      Object.assign(draft, {
        assignment: null,
        assignments: null,
        async_integrations: [],
        authors: undefined,
        created_at: hit.created_at,
        direction: hit.initial_direction,
        events: null,
        id: hit.numeric_id,
        initial_channel: convertChannelCasing(
          hit.initial_channel,
          'truncate',
        ) as Conversation['initial_channel'],
        inboundmessagecount: hit.inboundmessagecount,
        live_assesment: null,
        is_closed: hit.status === 'closed',
        is_abandoned: false,
        last_seen: undefined,
        org_id: hit.organization_id,
        queue: null,
        ratings: [],
        requested_by: hit.requested_by,
        tags: [],
        last_message_created_at: hit.last_message_created_at ?? null,
        outboundmessagecount: hit.outboundmessagecount,
        pending_expiration_at: null,
        pending_at: null,
        pending_by: null,
        status: hit.status,
        is_callback_consumed: false,
        numeric_id: hit.numeric_id,
      });

      if (hit.status === 'closed') {
        draft.closed_at = hit.closed_at;
      }
      draft.queued_at = hit.queued_at ?? null;
      draft.queue = hit.queue;
      draft.attributes = {
        subject: hit.subject ?? '',
        ...(hit.initial_channel === 'email' ||
        hit.initial_channel === 'contact_form'
          ? {
              forwarded_from_email: hit.forwardedfromemail ?? '',
              from_email: hit.fromemail ?? '',
              integration_email: hit.integrationemail ?? '',
              sender_name: hit.sendername ?? '',
              to_email: hit.toemail ?? '',
            }
          : {}),
      };
    }),
    emailAddresses: null,
    extraParties: {},
    integrations: [],
    is_updating: false,
    isAssignedToMe: false,
    lastSeen: null,
    linkedConversations: [],
    messages: [],
    parentConversation: null,
    parentConversationRequester: null,
    previousConversations: null,
    requester: {
      id: hit.requested_by ?? '',
      name: hit.requester_name ?? '',
      avatar_url: hit.requester_avatar ?? null,
      phone_number: hit.requester_phone ?? null,
      email: hit.requester_email ?? null,
      type: 'contact',
      org_id: hit.organization_id,
      additional_emails: [],
      additional_phone_numbers: [],
      company_id: null,
      default_outbound_number: null,
      anonymized_at: null,
      given_name: null,
      family_name: null,
      is_banned_hack: null,
      has_scim_enabled: false,
      external_id: null,
      skills: null,
    },
    tempMessage: null,
    tempFormValues: null,
    tempWrapup: '',
    unread: 0,
  };

  return metaConversation;
};
